import { render, staticRenderFns } from "./tianj_man.vue?vue&type=template&id=614094dc&"
import script from "./tianj_man.vue?vue&type=script&lang=js&"
export * from "./tianj_man.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports